// extracted by mini-css-extract-plugin
module.exports = {"position_box":"ToolsPosition_position_box__BYX8U","title":"ToolsPosition_title__2wT-D","position":"ToolsPosition_position__2LVcs","option":"ToolsPosition_option__3fdOj"};